import { render } from "./hashtag_etiqueta.vue?vue&type=template&id=55427048&scoped=true"
import script from "./hashtag_etiqueta.vue?vue&type=script&lang=js"
export * from "./hashtag_etiqueta.vue?vue&type=script&lang=js"

import "./hashtag_etiqueta.vue?vue&type=style&index=0&id=55427048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55427048"]])

export default __exports__